export default "__VITE_ASSET__CSAUaIag__"